import { useState } from 'react';
import Fraction from '../components/Fraction';

export default function AddSubQuestion({ question, onAnswer, disabled }) {
  const { num1, den1, num2, den2, operator } = question.data;
  const [numVal, setNumVal] = useState('');
  const [denVal, setDenVal] = useState('');

  function handleSubmit() {
    if (!numVal || !denVal || disabled) return;
    onAnswer({ num: numVal, den: denVal });
    setNumVal('');
    setDenVal('');
  }

  function handleKey(e) {
    if (e.key === 'Enter') handleSubmit();
  }

  return (
    <div className="question-card">
      <p className="question-prompt">{question.prompt}</p>
      <div className="fraction-equation">
        <Fraction num={num1} den={den1} size="lg" />
        <span style={{ fontSize: '2rem', fontWeight: 300 }}>{operator}</span>
        <Fraction num={num2} den={den2} size="lg" />
        <span className="equals-sign">=</span>
        <div className="fraction-input-group">
          <span className="fraction-input-label">skaitītājs</span>
          <input
            type="number"
            min="1"
            value={numVal}
            onChange={e => setNumVal(e.target.value)}
            onKeyDown={handleKey}
            disabled={disabled}
            placeholder="?"
            autoFocus
          />
          <div className="fraction-input-divider" />
          <input
            type="number"
            min="1"
            value={denVal}
            onChange={e => setDenVal(e.target.value)}
            onKeyDown={handleKey}
            disabled={disabled}
            placeholder="?"
          />
          <span className="fraction-input-label">saucējs</span>
        </div>
      </div>
      <button
        className="submit-btn"
        onClick={handleSubmit}
        disabled={!numVal || !denVal || disabled}
      >
        Pārbaudīt
      </button>
    </div>
  );
}
